import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkCjkFriendly from 'remark-cjk-friendly';
import remarkCitations from './remarkCitations';
import { markdownComponents } from './components';

/**
 * One top-level markdown block. Memoized on its source string and the sources map, so finished blocks do
 * not re-render while the stream appends to the last one. react-markdown escapes HTML (no rehype-raw).
 */
function MarkdownBlock({ md, sourceById }) {
  const plugins = React.useMemo(
    () => [remarkGfm, remarkCjkFriendly, [remarkCitations, { sourceById }]],
    [sourceById],
  );
  return (
    <ReactMarkdown remarkPlugins={plugins} components={markdownComponents}>
      {md}
    </ReactMarkdown>
  );
}

export default React.memo(MarkdownBlock);
